const dietaryOptions = [
    'Vegan','Keto','Gluten-Free','Pescatarian','Non Spicy','Paleo','Ovotarian','Dairy-Free','Vegetarian',
    'Soy-Free', 'Lacto-tarian','Ovo-Lacto-tarian','Halal','Kosher','Allergic To Shellfish',
    'Allergic To Nuts','Allergic To Sesame'
]
export default dietaryOptions;